<template>
  <header class="c-toolbar">
    <div class="l-level">
      <div class="l-level__left">
        <img :src="image" class="logo" alt="" v-if="image">
        <module-logo class="logo" v-else-if="moduleIdentifier" :identifier="moduleIdentifier"/>
        <slot name="header-icon"/>
        <slot name="header-left"/>
        <h1 class="c-toolbar__title title">{{ title }}</h1>
      </div>
      <div class="l-level__right">
        <div class="l-level__item">
          <slot name="header-right"/>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  import ModuleLogo from '@/components/template/ModuleLogo'

  export default {
    props: {
      image: {
        type: String,
        required: false
      },
      moduleIdentifier: {
        type: String,
        required: false
      },
      title: {
        type: String,
        required: true
      }
    },
    components: {
      ModuleLogo
    }
  }
</script>

<style lang="sass" scoped>
  div[slot="header-icon"]
    .logo
      margin: 0

    img, i
      display: inline-block
      vertical-align: middle

    i
      font-size: 20px
      margin: 0 20px

    & + h1
      margin-left: 20px

  .logo
    max-height: 30px
    margin-right: 20px
</style>



// WEBPACK FOOTER //
// PageTitle.vue?2adb3978